@use '../../../scss/global/spacing';
@use '../../../scss/global/color';

@use './description.mixin' as mixins;
@use 'description.vars' as *;

:host {
  display: flex;
  flex-flow: row nowrap;
  gap: spacing.$spacer-1;
}

@include mixins.description;
@include mixins.description-disabled;
@include mixins.description-hiden;
